import { createAction } from '@lifesize/typescript-react-redux-utils';

export const FETCH_RECORDINGS_AUTH = 'FETCH_RECORDINGS_AUTH';

export const fetchRecordingsAuth = () => {
  return createAction( FETCH_RECORDINGS_AUTH );
};
